<script setup lang="ts">
/**
 * Tiny scope-indicator badge that tells the user whether what they're
 * about to create will be private to their org or visible to everyone.
 *
 * Used in the header of every quick-add form so there's zero ambiguity
 * about content ownership at create time — addresses the CWR vs tenant
 * scoping confusion from the original E14 flow.
 */
import { computed } from 'vue';
import { useAuthStore } from '@/stores/authStore';

const authStore = useAuthStore();

const isCwrStaff = computed(() => authStore.user?.orgSlug === 'admin');
const orgName = computed(() => authStore.user?.orgName ?? 'your organization');

const label = computed(() =>
  isCwrStaff.value
    ? 'Global — visible to all CWR customers'
    : `Private to ${orgName.value}`,
);
</script>

<template>
  <span
    class="quick-add-scope-label text-[10px] uppercase tracking-wider rounded px-1.5 py-0.5 whitespace-nowrap"
    :class="isCwrStaff ? 'bg-accent-blue/15 text-accent-blue' : 'bg-surface-700 text-text-muted'"
    data-qa-scope-label
  >
    {{ label }}
  </span>
</template>
